"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowSelection = void 0;
const react_1 = __importStar(require("react"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const checkbox_1 = require("../../components/checkbox/checkbox");
const table_context_1 = require("./table-context");
function TableRowSelection({ value, }) {
    const { toggleRowSelection } = react_1.useContext(table_context_1.TableContext);
    const { selected } = react_1.useContext(table_context_1.TableSelectedContext);
    const handleSelectClick = event_callback_hook_1.useEventCallback(() => {
        toggleRowSelection(value.id);
    });
    return (react_1.default.createElement(checkbox_1.Checkbox, { value: selected.includes(value.id), onChange: handleSelectClick, highlighted: false }));
}
exports.TableRowSelection = TableRowSelection;
//# sourceMappingURL=table-row-selection.js.map